import { useState, useEffect } from 'react';
import { differenceInMilliseconds } from 'date-fns';
import PropTypes from 'prop-types';

const hasDateTimeOccurred = (eventDateTime) => {
    return eventDateTime <= new Date();
};

function useHasEventTimePassed(eventDateTime) {
    const [hasPassed, setHasPassed] = useState(hasDateTimeOccurred(eventDateTime));

    //lifecycle
    useEffect(() => {
        let timeout = null;
        let timeoutLength = 0;

        if (!hasDateTimeOccurred(eventDateTime)) {
            timeoutLength = differenceInMilliseconds(eventDateTime, new Date());

            timeout = setTimeout(() => {
                setHasPassed(hasDateTimeOccurred(eventDateTime));
            }, timeoutLength);
        }

        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        }
    }, [eventDateTime]);

    return hasPassed;
}

useHasEventTimePassed.propTypes = {
    eventDateTime: PropTypes.instanceOf(Date)
};

export default useHasEventTimePassed;